module.exports = __webpack_public_path__ + "img/light.2233dbe3.png";